import React, { useEffect, useRef, useState } from "react";
import styles from './contact-us.module.scss'
import { connect } from "react-redux";
import LayoutFull from "../layouts/layoutFull/LayoutFull";
import Breadcrumb, { BreadcrumbLayer } from "../components/Breadcrumb";
import Loading from "../components/Loading";
import Input from "../components/Input";
import Button from "../components/ripple/Button";
import { store } from "../redux/store";
import { addModalLayer, wipeModalState } from "../redux/actions/ModalActions";
import ReCaptcha from "../components/ReCaptcha";
import { DEBUG } from "../settings/global";
import { createFetch } from "../helpers/fetch/FetchRequest";
import { dispatchNotification } from "../layouts/app/components/notificationSystem/notifications";
import { Loader } from "@googlemaps/js-api-loader";
import getPages from "../helpers/data/get/pages";
import SeoApiHandler from "../helpers/seo/SeoApiHandler";
import Page, { Block } from "../layouts/Content";
import {
    COMPANY_ADDRESS,
    COMPANY_CITY,
    COMPANY_COUNTRY,
    COMPANY_EMAIL,
    COMPANY_PHONE_NUMBER,
    COMPANY_POSTAL_CODE
} from "../settings/content/organization";
import { NAV_CONTACT } from "../settings/navigation";
import { API_CUSTOM_REQUEST_NODE } from "../settings/endpoints/app";

export async function getStaticProps() {
    return {
        props: {seo: await getPages(NAV_CONTACT)},
    }
}

function Contact({seo, ...props}) {

    let captchaRef = useRef();
    const googlemap = useRef();

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [inputs, updateInputs] = useState({message: '', email: ''});
    const [captcha, setCaptcha] = useState(null);
    const [errors, updateErrors] = useState({});

    const resetCaptcha = () => {
        setCaptcha(null);
        if (!!captchaRef && !!captchaRef.current) captchaRef.current.reset();
    }

    useEffect(() => {
        const loader = new Loader({
            apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY,
            version: 'weekly',
            libraries: ['places']
        });
        let map;
        loader.load().then(() => {
            map = new google.maps.Map(googlemap.current, {
                center: {lat: 47.039457437869395, lng: 28.803736813739647},
                place: 'OPTIMUM+WEB+COMPANY',
                title: "test",
                zoom: 16,
            });
            new google.maps.Marker({
                position: {lat: 47.039457437869395, lng: 28.803736813739647},
                map,
                draggarble: false,
            });
        });
    }, [])

    useEffect(() => {
        if (!!props.user && !!props.user.email) updateInputs({...inputs, ...{email: props.user.email}})
    }, [props.user]);

    useEffect(() => {
        if (!!captcha) sendRequest();
    }, [captcha]);

    useEffect(() => {
        return () => {store.dispatch(wipeModalState())};
    }, []);

    const sendRequest = () => {
        setLoading(true);
        createFetch({
            URL: API_CUSTOM_REQUEST_NODE,
            method: 'POST',
            body: {...inputs, ...{reCaptcha: captcha}},
            onSuccess: response => {
                resetCaptcha();
                setTimeout(() => {
                    store.dispatch(wipeModalState());
                }, 200);
                setLoading(false);
                dispatchNotification({
                    message: 'Your message has been sent. Thank you for your interest!',
                    type: 'success',
                    url: API_CUSTOM_REQUEST_NODE,
                    requestTitle: 'Contact us request',
                    responseContent: response,
                    status: status,
                });
                updateInputs({message: '', apps: '', email: ''});
                setCaptcha(null);
                updateErrors({});
                setSuccess(true);
            },
            onError: response => {
                resetCaptcha();
                setTimeout(() => {
                    store.dispatch(wipeModalState());
                }, 200);
                setLoading(false);
                let {error, responseBody} = response;
                let {status} = error;
                let message = 'Something went wrong. Please, try again later';

                if (status === 400) {
                    message = 'Some of the fields are incorrect. Please, recheck them and try again';
                    if (responseBody?._error?.message === 'Captcha ERROR. Please prove you are not a robot') {
                        message = 'Captcha ERROR. Please prove you are not a robot';
                    } else if (typeof responseBody?._error?.message === 'object') {
                        updateErrors(responseBody?._error?.message)
                    }
                }

                dispatchNotification({
                    message: message,
                    type: 'error',
                    url: API_CUSTOM_REQUEST_NODE,
                    requestTitle: 'Contact us request',
                    responseContent: responseBody?.['_error'],
                    status: status,
                });
            },
        })
    }

    const onChange = e => {
        const {name, value} = e.target;
        updateInputs({...inputs, ...{[name]: value}});
    };

    const onSubmit = (e) => {
        e.preventDefault();
        store.dispatch(addModalLayer({
            component: (
                <ReCaptcha
                    getRef={el => captchaRef = el}
                    onErrored={data => DEBUG ? console.log(data) : () => {}}
                    onChange={value => setCaptcha(value)}
                />
            ),
        }))
    };

    const renderForm = () => {

        const isSuccess = success ? ` ${styles['form__success--active']}` : '';

        return (
            <form
                method="post"
                action="#"
                onSubmit={onSubmit}
                className={styles["form"]}
            >
                {
                    !!loading &&
                    <Loading
                        type='component-cover'
                        icon={{faCode: 'fas fa-arrow-up', animationType: 'top',}}
                        coverBorderRadius='0'
                        message='Sending...'
                    />
                }
                <Input
                    placeholder='Email'
                    type="email"
                    name='email'
                    iconLeft='fas fa-envelope'
                    onChange={onChange}
                    value={inputs.email}
                    isValid={!!errors['email'] ? false : undefined}
                    error={errors['email']}
                    pattern='^"*\w+"*([\.\+"!#$%&‘*–/=?^`{|}~-]?\w+)*@([a-z0-9]([-a-z0-9]{0,61}[a-z0-9])?\.)?([a-z0-9]([-a-z0-9]{0,61}[a-z0-9])?\.)?([a-z0-9]([-a-z0-9]{0,252}[a-z0-9])?)\.([a-z]{2,63})$'
                    visualVariables={{
                        height: '5rem',
                        borderRadius: '15px',
                        colorBorder: 'transparent',
                        colorBackground: 'var(--colorBackgroundBasic)',
                    }}
                    required
                />
                <Input
                    type="textarea"
                    placeholder='Message'
                    name='message'
                    iconLeft='fas fa-comment'
                    onChange={onChange}
                    value={inputs.message}
                    isValid={!!errors['message'] ? false : undefined}
                    error={errors['message']}
                    autoComplete='new-password'
                    visualVariables={{
                        minHeight: '15rem',
                        maxHeight: '30rem',
                        height: '5rem',
                        borderRadius: '15px',
                        colorBorder: 'transparent',
                        colorBackground: 'var(--colorBackgroundBasic)',
                    }}
                    autoFocus
                    required
                />
                <Button
                    className={styles['form__submit']}
                    type={loading ? 'button' : 'submit'}
                    title="Send"
                    iconRight="fas fa-paper-plane"
                    color={'#2196f3'}
                    visuals={{height: '4rem', borderRadius: '15px'}}
                />
                <div className={`${styles['form__success']}${isSuccess}`}>
                    <div className={styles['form__success__header']}>
                        <i className={`far fa-check-circle ${styles['form__success__header__icon']}`}/>
                        <p className={styles['form__success__header__title']}>
                            Your message has been successfully submitted!
                        </p>
                    </div>
                    <Button
                        className={styles['form__success__button']}
                        title='Send another message'
                        onClick={() => setTimeout(() => setSuccess(false), 300)}
                        displayType='text'
                        type='button'
                    />
                </div>
            </form>
        )
    }

    const renderInfo = () => (
        <div className={styles['info']}>
            <div className={styles['info__title']}>
                <h1>Contact Us</h1>
                <h4>We are here to help!</h4>
            </div>
            <div className={styles["info__data"]}>
                <div className={styles["info__data__item"]}>
                    <i className={`fas fa-mobile-alt ${styles["info__data__item__icon"]}`}/>
                    <a href={`tel:${COMPANY_PHONE_NUMBER}`} className={styles['info__data__item__phone']}>
                        {COMPANY_PHONE_NUMBER.slice(0, 1)}
                        ({COMPANY_PHONE_NUMBER.slice(1, 4)}) {' '}
                        {COMPANY_PHONE_NUMBER.slice(4, 6)} {' '}
                        {COMPANY_PHONE_NUMBER.slice(6, 9)} {' '}
                        {COMPANY_PHONE_NUMBER.slice(9, 12)} {' '}
                    </a>
                </div>
                <div className={styles["info__data__item"]}>
                    <i className={`fas fa-envelope ${styles["info__data__item__icon"]}`}/>
                    <a
                        href={`mailto:${COMPANY_EMAIL}`}
                        className={styles["info__data__item__mail"]}
                    >
                        {COMPANY_EMAIL}
                    </a>
                </div>
                <div className={styles["info__data__item"]}>
                    <i className={`fas fa-map-marker-alt ${styles["info__data__item__icon"]}`}/>
                    <div className={styles["info__data__item__address"]}>
                        <span>{COMPANY_ADDRESS}</span>
                        <span>{COMPANY_COUNTRY}, {COMPANY_CITY}, {COMPANY_POSTAL_CODE}</span>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <LayoutFull>
            <SeoApiHandler data={seo}/>
            <Page className={styles['contacts-layout']}>
                <Block>
                    <Breadcrumb inverse>
                        <BreadcrumbLayer link='/' name='Home'/>
                        <BreadcrumbLayer name='Contact us'/>
                    </Breadcrumb>
                </Block>
                <Block className={styles['contacts-overlay']}>
                    <div className={`page-content__block__container-centered ${styles['contacts']}`}>
                        <div className={styles["contacts__content"]}>
                            {renderInfo()}
                            {renderForm()}
                        </div>
                        <div className={styles["contacts__map"]}>
                            <div id="map" ref={googlemap}/>
                        </div>
                    </div>
                </Block>
            </Page>
        </LayoutFull>
    )
}

const mapStateToProps = state => ({
    user: state.userData.user,
})

export default connect(mapStateToProps)(Contact)